/**
 * Persistência do consentimento de cookies (LGPD).
 *
 * Fonte única para o valor salvo em localStorage, usada pelo banner de
 * cookies e por qualquer link futuro de "Preferências de cookies".
 *
 * Valores possíveis: 'all' (aceitou todos) | 'necessary' (só necessários) | null (ainda não decidiu).
 */
export const COOKIE_CONSENT_KEY = 'gabriela_cookie_consent';
export const COOKIE_CONSENT_RESET_EVENT = 'gabriela-cookie-consent-reset';

export function getCookieConsent() {
  try {
    return localStorage.getItem(COOKIE_CONSENT_KEY);
  } catch (e) {
    return null;
  }
}

export function setCookieConsent(value) {
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, value);
  } catch (e) {
    // localStorage indisponível (modo privado, cookies bloqueados etc.) — segue sem persistir
  }
}

/**
 * Limpa o consentimento salvo e avisa quem estiver ouvindo (o próprio banner)
 * para que ele reapareça sem precisar recarregar a página.
 */
export function resetCookieConsent() {
  try {
    localStorage.removeItem(COOKIE_CONSENT_KEY);
  } catch (e) {
    // localStorage indisponível
  }

  try {
    window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_RESET_EVENT));
  } catch (e) {
    // ambiente sem suporte a CustomEvent
  }
}
